import "./newLostStudents.css";
import React, { useContext } from "react";
import MonthChoice from "../../components/MonthChoice";
import Changes from "./Changes";
import NewStudents from "./NewStudents";
import LostStudents from "./LostStudents";
import HtTabs from "../../components/HtTabs";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { LanguageContext } from "../../../../Context";
import PendingToActive from "./PendingToActive";
import StoppedToActive from "./StoppedToActive";
import ActiveToPending from "./ActiveToPending";
import { useNavigate, useParams } from "react-router-dom";

export default function NewLostStudents() {
  let {language } = useContext(LanguageContext)
 
/*   const [year, setYear] = React.useState(new Date().getFullYear());
  const [month, setMonth] = React.useState(new Date().getMonth()); */
  let { year, month,page } = useParams()
  year = parseInt(year)
  month = parseInt(month-1)
 const navigate = useNavigate()
  const cprops = {year,month}
  console.log(year,month)

  const labels=[`Today`,`New`,`Stopped`,<>Pending {<ArrowRightIcon />} Active</>,<>Stopped {<ArrowRightIcon />} Active</>,<>Active {<ArrowRightIcon />} Pending</>]
  const components = [<Changes {...cprops} />, <NewStudents {...cprops} />, <LostStudents {...cprops} />, <PendingToActive {...cprops} />, <StoppedToActive {...cprops} />,<ActiveToPending {...cprops} />]


  return (
    <HtTabs
      labels={labels}
      components={components}
      nextToTabs={
        <MonthChoice
          month={month}
          year={year}
          language={language}
          setMonth={(newMonth) => navigate(`/newlost/today/${year}/${newMonth+1}`)}
          setYear={(newYear) => navigate(`/newlost/today/${newYear}/${month+1}`)}
        />
      }
      defaultValue={labels.findIndex(l => l.toLowerCase() === page)}
      navigate={`/newlost/:page/${year}/${month+1}`}
    />
  );
}
